import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    /** 搜索输入 */
    public keyword: string = '';
    public saveKeyword: string = '';
    /** 筛选表单条件 */
    public filterList: {
        issueDateBegin?: number;
        issueDateEnd?: number;
        documentType?: string[];
        lastModifyTimeBegin?: number;
        lastModifyTimeEnd?: number;
        role?: string[];
        status?: string[];
        isArchived: boolean;
    } = {
        issueDateBegin: undefined,
        issueDateEnd: undefined,
        documentType: [],
        lastModifyTimeBegin: undefined,
        lastModifyTimeEnd: undefined,
        role: [],
        status: [],
        isArchived: false,
    };
    /** 日期格式 */
    public dateFormat: string = 'YYYY-MM-DD';
    /** 分页信息 */
    pageNum: number = 1;
    pageSize: number = 20;
    total: number = 0;
    /** 选择筛选框 选中的item */
    public searchActive: string = '';
    /** 新增单据类型 弹框 */
    public selectBillTypeM: boolean = false;
    /** 拒绝 弹框 */
    public refuseM: boolean = false;
    public selectDocumentUUID: string = '';
    public refuseType: string = '';
    public clickDocumentType: string = '';  
    /** 拒绝理由输入 */
    public refuseInputNum: number = 0;
    /** 表格数据 */
    public dataList: {
        actualDocumentType: string;
        documentUUID: string;
        tenantID: string;
        documentID: string;
        createTime: number;
        lastModifyTime: number;
        documentType: string;
        status: string;
        allowedTargetStatus: string[];
        role: string;
        counterparty: string;
        sender: string;
        receiver: string;
        isArchived: boolean;
    }[] = [];
    /** 新增单据类型 选择 */
    public createBillType: string = '';
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/DocumentList/Modules.State.ts